
import { defineComponent, reactive, toRefs } from "vue";
import lMenu from "./menu.vue";
import lHeader from "./header.vue";
import lTab from "./tab.vue";

export default defineComponent({
  components: {
    lMenu,
    lHeader,
    lTab,
  },
  setup() {
    const fixed = reactive({
      fixedLW: 0,
      setLW: (w: number) => {
        fixed.fixedLW = w;
      },
    });
    return {
      ...toRefs(fixed),
    };
  },
});
